import React from "react";
import { FaEnvelope, FaPhone, FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import frontImg from "../img/schronisko_front.webp";
import "./MainPage.css";

function MainPage() {
  return (
    <div className="main-page">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-left">
          <FaEnvelope className="icon" />
          <span>schronisko.bartne@gmail.com</span>
        </div>
        <div className="navbar-right">
          <FaPhone className="icon" />
          <span>+48 18 351 80 32</span>
        </div>
      </nav>

      {/* Main Image */}
      <div className="main-image">
        <img src={frontImg} alt="Schronisko Bartne" />

        {/* Text on the image */}
        <div className="hero-text">
          <h1>SCHRONISKO PTTK - 655 m n.p.m.</h1>
          <h2>Bartne</h2>
          <p>
            "Schronisko w Bartnym to drewniana chata położona w lesie, gdzie wciąż jeszcze
            słychać skrzypienie drewnianych podłóg. To miejsce gdzie kończy się cywilizacja
            a zaczyna spokój gór i lasów. Zapraszamy do Krainy Łagodności"
          </p>
        </div>
      </div>







{/* Google Maps Section */}
<div className="map-section">
  <h3>Schronisko PTTK Bartne – Lokalizacja</h3>
  <p>Znajdujemy się w sercu Beskidu Niskiego, w spokojnej dolinie Bartnego.</p>

  <iframe
    title="Google Maps Bartne"
    width="300"
    height="300"
    style={{ border: 0, borderRadius: "12px" }}
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3247.356987012345!2d21.337!3d49.589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473c1b7d8e5b1e2b%3A0x469e2b6d4a0e6c4a!2sSchronisko%20PTTK%20Bartne!5e0!3m2!1spl!2spl!4v1710000000000">
  </iframe>
</div>








      {/* Footer */}
      <footer className="footer">
        <h2>BACÓWKA BARTNE</h2>
        <p>
          Ewa Biel<br />
          <strong>KONTAKT</strong><br />
          Telefon: +48 18 351 80 32<br />
          E-mail: schronisko.bartne@gmail.com
        </p>
        <div className="social-icons">
          <FaFacebook />
          <FaInstagram />
          <FaWhatsapp />
        </div>
      </footer>
    </div>
  );
}

export default MainPage;
